import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay = 300): [T] {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(timeoutId);
  }, [value, delay]);

  return [debounced];
}

export function useHotkeys(bindings: Array<[string, (event: KeyboardEvent) => void]>) {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      // Browser autofill fires keydown events with no key
      if (!event.key) return;
      const key = event.key.toLowerCase();
      const hasCtrl = event.ctrlKey || event.metaKey;
      const hasShift = event.shiftKey;

      for (const [combo, callback] of bindings) {
        const normalized = combo.toLowerCase();
        const wantsCtrl = normalized.includes('mod') || normalized.includes('ctrl');
        const wantsShift = normalized.includes('shift');
        const parts = normalized.split('+');
        const targetKey = parts[parts.length - 1];

        if (wantsCtrl === hasCtrl && wantsShift === hasShift && key === targetKey) {
          callback(event);
        }
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [bindings]);
}

